import {api} from "./index";
import {PageRequest, PageResponse} from "../../shared/types/page";
import {Student, StudentCreateRequest, StudentUpdateRequest, StudentView} from "../../shared/types/student";

export const createStudentFetch = async (request: StudentCreateRequest): Promise<Student> => {
  const response = await api.post<Student>(
      `/students`,
      request
  );
  return response.data;
};

export const updateStudentFetch = async (
    id: number,
    request: StudentUpdateRequest
): Promise<Student> => {
  const response = await api.patch<Student>(
      `/students/${id}`,
      request
  );
  return response.data;
};

export const loadStudentByIdFetch = async (id: number): Promise<Student> => {
  const response = await api.get<Student>(
      `/students/${id}`
  );
  return response.data;
};

export const switchStudentStatusFetch = async (id: number): Promise<Student> => {
  const response = await api.post<Student>(
      `/students/${id}/switch/enabled`
  );
  return response.data;
};

export const getAllStudentsFetch = async (
    pageRequest: PageRequest
): Promise<PageResponse<StudentView>> => {
  const response = await api.post<PageResponse<StudentView>>(
      `/views/students/paginate`,
      pageRequest
  );
  return response.data;
};

export const getEnabledStudentsCountFetch = async (): Promise<number> => {
  const response = await api.post<number>(
      `/students/count/enabled`
  );
  return response.data;
};